import { runClientComponent } from '../../_common/client/client-component-runner';
import { BreadcrumbComponent } from './breadcrumb.component';

runClientComponent({ BreadcrumbComponent });
